import React from 'react';
import { useLanguage } from '../context/LanguageContext';

const Clients = () => {
  const { language } = useLanguage();

  const clients = [
    { 
      name: 'Самрук-Қазына',
      logo: 'https://customer-assets.emergentagent.com/job_fcb14fdd-e1e9-4f89-9c3e-4d92dcef6695/artifacts/gx9mmofw_IMG_9074.PNG'
    },
    { 
      name: 'Департамент государственных доходов',
      logo: 'https://customer-assets.emergentagent.com/job_fcb14fdd-e1e9-4f89-9c3e-4d92dcef6695/artifacts/2iebum82_IMG_9077.WEBP',
      needsWhiteBg: true
    },
    { 
      name: 'BI Group',
      logo: 'https://customer-assets.emergentagent.com/job_fcb14fdd-e1e9-4f89-9c3e-4d92dcef6695/artifacts/wecm4cn6_IMG_9075.WEBP'
    },
    { 
      name: 'Bazis-A',
      logo: 'https://customer-assets.emergentagent.com/job_fcb14fdd-e1e9-4f89-9c3e-4d92dcef6695/artifacts/sb9anrw0_IMG_9076.WEBP'
    },
    { 
      name: 'Svoy Dom',
      logo: 'https://customer-assets.emergentagent.com/job_c20eb127-1445-4e6d-9d8b-fd2557fbc81d/artifacts/7tclljrz_IMG_9078.WEBP'
    },
    { 
      name: 'Qazaq Stroy',
      logo: 'https://customer-assets.emergentagent.com/job_c20eb127-1445-4e6d-9d8b-fd2557fbc81d/artifacts/edlwvlq2_IMG_9080.WEBP'
    }
  ];

  const title = {
    ru: 'Нам доверяют',
    kz: 'Бізге сенеді',
    en: 'Our Clients'
  };

  return (
    <section className="pt-6 py-2 pb-6 bg-[#061d36]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-bold text-white text-center mb-4">
          {title[language]}
        </h2>
        <p className="text-white/70 text-center mb-8 md:mb-12 max-w-2xl mx-auto text-sm md:text-base">
          {language === 'ru' ? 'Ведущие компании Казахстана выбирают наши панели для своих проектов' :
           language === 'kz' ? 'Қазақстанның жетекші компаниялары өз жобалары үшін біздің панельдерді таңдайды' :
           'Leading companies in Kazakhstan choose our panels for their projects'}
        </p>
        
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 md:gap-6 max-w-7xl mx-auto">
          {clients.map((client, index) => (
            <div
              key={index}
              className="group flex flex-col items-center justify-center p-4 md:p-6 bg-white rounded-2xl transition-all duration-300 hover:shadow-xl hover:-translate-y-1"
            >
              {/* Logo */}
              <div 
                className="w-24 h-24 flex items-center justify-center mb-4 bg-white rounded-xl overflow-hidden"
                style={client.needsWhiteBg ? { padding: '8px' } : {}}
              >
                <div 
                  className={`w-full h-full flex items-center justify-center ${client.needsWhiteBg ? 'bg-white overflow-hidden' : ''}`}
                  style={client.needsWhiteBg ? { borderRadius: '50%' } : {}}
                >
                  <img 
                    src={client.logo}
                      loading="lazy" 
                    alt={client.name}
                    className={`max-w-full max-h-full object-contain transition-transform group-hover:scale-110`}
                    style={{ 
                      backgroundColor: 'white',
                      ...(client.needsWhiteBg && { 
                        transform: 'scale(1.3)'
                      })
                    }}
                  />
                </div>
              </div>
              
              {/* Company Name */}
              <h3 className="text-sm font-semibold text-[#061d36] text-center leading-tight">
                {client.name}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Clients;
